// ─────────────────────────────────────────────────────────────────────────────────────────────────────────────
// LE VISTE DELLA SCACCHIERA (codice CAL…): il recorder dice a chi scatta dove mettersi, una foto alla volta, e disegna sull'inquadratura il
// riquadro in cui deve cadere la scacchiera. La calibrazione ha bisogno di viste DIVERSE: in tutte le parti della foto (la distorsione è più forte
// ai bordi e si misura solo dove ci sono angoli) e storte di parecchio (20–35°). 02/11/2026: con la sola frase le viste sono rimaste tutte nel
// quarto in alto a destra, e la distorsione ai bordi non si è potuta stimare.
// ─────────────────────────────────────────────────────────────────────────────────────────────────────────────

/** Una vista: cosa fare, e dove deve cadere la scacchiera nella foto (frazioni di larghezza e altezza: x0, y0, x1, y1). */
export interface CalibrationStep {
  text: string;
  area: readonly [number, number, number, number];
}

const FULL = [0.05, 0.2, 0.95, 0.8] as const;
const CENTRE = [0.15, 0.3, 0.85, 0.7] as const;

/** Prima le posizioni nella foto (angoli e bordi), poi le inclinazioni: corte, si leggono sulla pistola mentre si inquadra. */
export const CALIBRATION_STEPS: readonly CalibrationStep[] = [
  { text: 'Di fronte, la scacchiera riempie il riquadro', area: FULL },
  { text: 'In alto a sinistra', area: [0, 0, 0.6, 0.4] },
  { text: 'In alto a destra', area: [0.4, 0, 1, 0.4] },
  { text: 'In basso a sinistra', area: [0, 0.6, 0.6, 1] },
  { text: 'In basso a destra', area: [0.4, 0.6, 1, 1] },
  { text: 'Contro il bordo sinistro', area: [0, 0.3, 0.5, 0.7] },
  { text: 'Contro il bordo destro', area: [0.5, 0.3, 1, 0.7] },
  { text: 'Mezza fuori dal bordo alto', area: [0.1, 0, 0.9, 0.25] },
  { text: 'Mezza fuori dal bordo basso', area: [0.1, 0.75, 0.9, 1] },
  { text: 'Spostati a sinistra: storta', area: CENTRE },
  { text: 'Ancora più a sinistra: molto storta', area: CENTRE },
  { text: 'Spostati a destra: storta', area: CENTRE },
  { text: 'Ancora più a destra: molto storta', area: CENTRE },
  { text: 'Alza la pistola e punta in giù', area: CENTRE },
  { text: 'Ancora più in alto, punta molto in giù', area: CENTRE },
  { text: 'Abbassa la pistola e punta in su', area: CENTRE },
  { text: 'Ancora più in basso, punta molto in su', area: CENTRE },
  { text: 'In alto a sinistra, storta', area: [0, 0, 0.6, 0.4] },
  { text: 'In basso a destra, storta', area: [0.4, 0.6, 1, 1] },
  { text: 'Da lontano, al centro', area: [0.3, 0.38, 0.7, 0.62] },
];

/** Lo scatto numero `done + 1`: la frase e il riquadro; dopo l'ultimo, che si può esportare (e nessun riquadro). */
export function calibrationStep(done: number): { prompt: string; area: CalibrationStep['area'] | null } {
  const total = CALIBRATION_STEPS.length;
  const step = CALIBRATION_STEPS[done];
  return step
    ? { prompt: `Foto ${done + 1} di ${total}: ${step.text}`, area: step.area }
    : { prompt: `Fatte ${total} foto: tocca Esporta`, area: null };
}

/** Il suffisso del caso numero n (da 0): a…z, poi aa, ab… — mai caratteri che un file system rifiuta (dopo la z c'erano «{» e «|»). */
export function caseSuffix(n: number): string {
  let s = '';
  let k = n;
  do {
    s = String.fromCharCode(97 + (k % 26)) + s;
    k = Math.floor(k / 26) - 1;
  } while (k >= 0);
  return s;
}
